import { PageHeader } from '@ksyos/design-system';
import { SupportFeatureFlags } from '@common/contexts/support/domain/enums/featureFlags';
import { ManagerAuthorization } from '@common/enums';
import { TabbedSection } from '@frontend/components/elements/TabbedSection';
import { getSelectedLanguage } from '@frontend/translate';
import { assertHasAuthorization } from '@frontend/utils';
import { useFeatureFlag } from '@frontend/utils/hooks/useFeatureFlag';
import { PageTemplate } from '../../templates/PageTemplate';
import { AdminProcessesList } from './AdminProcessesList';
import { AdminProcessesOpen } from './AdminProcessesOpen';

export function AdminProcesses() {
    assertHasAuthorization(ManagerAuthorization.adminProcessRead);

    const language = getSelectedLanguage();
    const isSupportExporterEnabled = useFeatureFlag(SupportFeatureFlags.EnableSupportExporter, false);

    return (
        <PageTemplate>
            <PageHeader title={language.request.processes} />
            <TabbedSection pages={getPages()} />
        </PageTemplate>
    );

    function getPages() {
        const pages = [
            {
                content: <AdminProcessesList />,
                title: language.request.allProcesses,
                url: '/processes',
            },
        ];

        if (isSupportExporterEnabled) {
            pages.push({
                content: <AdminProcessesOpen />,
                title: language.request.openProcesses,
                url: '/processes/open',
            });
        }

        return pages;
    }
}
